const checkMimeType = event => {
  let files = event.target.files
  let err = ''
  const types = ['image/png', 'image/jpeg', 'image/jpg']
  for (var x = 0; x < files.length; x++) {
    // eslint-disable-next-line no-loop-func
    if (types.every(type => files[x].type !== type)) {
      err += 'Arquivo com formato não suportado\n'
    }
  }

  if (err !== '') {
    event.target.value = null
    console.log(err)
    return { err }
  }
  return true
}

export default checkMimeType
